import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

const PageHero = ({ title, subtitle, breadcrumbs = [], badge }) => {
  return (
    <section
      className="relative overflow-hidden py-20 md:py-28"
      style={{
        background:
          "linear-gradient(135deg, #061b13 0%, #0a2e1f 50%, #0f5132 100%)",
      }}
    >
      <div
        className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full blur-3xl opacity-25 pointer-events-none"
        style={{
          background:
            "radial-gradient(circle, #10b981 0%, transparent 70%)",
        }}
      />
      <div
        className="absolute -bottom-40 -left-40 w-[500px] h-[500px] rounded-full blur-3xl opacity-20 pointer-events-none"
        style={{
          background:
            "radial-gradient(circle, #34d399 0%, transparent 70%)",
        }}
      />
      <div
        className="absolute inset-0 opacity-[0.05] pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.4) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.4) 1px, transparent 1px)",
          backgroundSize: "60px 60px",
        }}
      />

      <div className="relative z-10 max-w-[1200px] mx-auto px-6 text-center">
        {badge && (
          <span className="inline-block text-xs font-bold uppercase tracking-[0.25em] mb-4 px-3 py-1 rounded-full bg-emerald-500/15 text-emerald-200 border border-emerald-400/30">
            {badge}
          </span>
        )}
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-5 tracking-tight">
          {title}
        </h1>
        {subtitle && (
          <p className="text-emerald-100/80 max-w-2xl mx-auto text-base md:text-lg leading-relaxed">
            {subtitle}
          </p>
        )}
        {breadcrumbs.length > 0 && (
          <div className="mt-8 flex items-center justify-center gap-2 text-sm text-emerald-200/70">
            <Link to="/" className="hover:text-emerald-300 transition-colors">Home</Link>
            {breadcrumbs.map((crumb, idx) => (
              <React.Fragment key={idx}>
                <ChevronRight size={14} />
                {crumb.to ? (
                  <Link to={crumb.to} className="hover:text-emerald-300 transition-colors">{crumb.label}</Link>
                ) : (
                  <span className="text-emerald-300">{crumb.label}</span>
                )}
              </React.Fragment>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default PageHero;
